module.exports = __webpack_public_path__ + "public/img/digimind-logo.3d278e1b.png";